<template>
    <d-container fluid class="main-content-container px-4">
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <h3 class="page-title">{{ affiliate.human_readable_name }}</h3>
            </div>
        </div>
        <d-row>
            <d-col lg="12">
                <d-card class="card-small card-post card-post--aside card-post--1">
                    <daisycon-oauth-connect-network v-if="affiliate.type == 'daisycon-oauth'" :network-name="networkName" :affiliate="affiliate"/>
                    <postback-connectNetwork v-if="affiliate.type == 'postback'" :network-name="networkName" :affiliate="affiliate"/>
                    <general-connectNetwork v-if="affiliate.type == 'api'" :affiliate="affiliate" :network-name="networkName"/>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
    import { AffiliateNetworkService } from '@/main';
    import daisyconOauthConnectNetwork from '@/components/daisycon-oauth/DaisyconOauthConnectNetwork.vue';
    import postbackConnectNetwork from '@/components/postback/PostbackConnectNetwork.vue';
    import generalConnectNetwork from '@/components/network/GeneralConnectNetwork.vue';

    export default {
        components: {
            daisyconOauthConnectNetwork,
            postbackConnectNetwork,
            generalConnectNetwork
        },

        data() {
            return {
                networkName: "",
                affiliate: []
            };
        },

        methods: {
            async getById() {
                const affiliateInfo = await AffiliateNetworkService.getById(this.$route.params.networkId)
                this.affiliate = affiliateInfo
                this.networkName = affiliateInfo.name
            },
        },

        created () {
            this.getById()
        }
    };
</script>
